/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Enteremailsuffix2Inputs */

const zh_danger_enteremailsuffix2 = /** @type {(inputs: Danger_Enteremailsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以确认`)
};

const en_danger_enteremailsuffix2 = /** @type {(inputs: Danger_Enteremailsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to confirm`)
};

const es_danger_enteremailsuffix2 = /** @type {(inputs: Danger_Enteremailsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para confirmar`)
};

/**
* | output |
* | --- |
* | "to confirm" |
*
* @param {Danger_Enteremailsuffix2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_enteremailsuffix2 = /** @type {((inputs?: Danger_Enteremailsuffix2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Enteremailsuffix2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_enteremailsuffix2(inputs)
	if (locale === "en") return en_danger_enteremailsuffix2(inputs)
	return es_danger_enteremailsuffix2(inputs)
});
export { danger_enteremailsuffix2 as "danger_enterEmailSuffix" }